module.exports = __webpack_public_path__ + "img/ring_g_s_null_null.e43dee88.png";